import { API } from '../config/constants.js'
import apiRequest from './request.js'

export const login = async (body) => {
  return apiRequest(`${API}/admin/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
}